function toggleBodyClass(className, action) {
  if (action === 'open') {
    document.body.classList.add(className);
  } else if (action === 'close') {
    document.body.classList.remove(className);
  }
  else if (action === 'toggle') {
    document.body.classList.toggle(className);
  }
  else {
    console.error('Invalid action: ' + action);
  }
}

export default toggleBodyClass;